// extracted by mini-css-extract-plugin
export default {"goButton":"SvgButton_goButton__RKXt7","small":"SvgButton_small__bDCFe","goButtonSvg":"SvgButton_goButtonSvg__gLc2-","goButtonLabel":"SvgButton_goButtonLabel__2KKyM"};